import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { useSpace } from "../../../hooks/useSpace";
import { keys } from "./keys";

export function useDeletePendingItem(subjectId: string) {
  const queryClient = useQueryClient();
  const { currentSpace } = useSpace();

  return useMutation({
    mutationFn: async (id: number) => {
      const { error } = await apiClient
        .from('subject_pending_items')
        .delete()
        .eq('id', id);

      if (error) throw error;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: keys.getPendingItems(subjectId) });
      if (currentSpace?.id) {
        queryClient.invalidateQueries({ queryKey: keys.pendingSubTopics(currentSpace.id) });
        queryClient.invalidateQueries({ queryKey: keys.openPendingItems(currentSpace.id) });
      }
    },
  });
}
